export default __webpack_public_path__ + "static/media/sb-ICO-04.3b383262.webp";